export const baseURL = process.env.REACT_APP_BASE_API_URL;
export const baseAssetURL = process.env.REACT_APP_BASE_ASSET_URL;
export const uploadURL = process.env.REACT_APP_UPLOAD_URL;
export const mediaStreamBaseUrl = process.env.REACT_APP_MEDIA_STREAM_BASE_URL;
export const blurredBackgroundEnabledFrom =
    process.env.REACT_APP_BLURRED_BACKGROUND_ENABLED_FROM;
